import { InputTextarea } from "primereact/inputtextarea";
import * as React from "react";

const PrwInputTextArea = (props: any) => {
  const { rows = 2, cols = 30, autoResize = true } = props;

  return (
    <div>
      <InputTextarea
        className={`p-inputtext-sm p-d-block ${
          props?.rawErrors?.length > 0 ? "p-invalid" : null
        }`}
        rows={rows}
        cols={cols}
        autoResize={autoResize}
        value={props.value}
        onChange={(e: any) => props.onChange(e.target.value)}
      />
    </div>
  );
};

export default PrwInputTextArea;
